import { RefObject, useEffect, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

const useShowScrollShadow = (ref: RefObject<HTMLElement>) => {
  const [showShadow, setShowShadow] = useState(true)

  const handleScroll = () => {
    if (ref.current) {
      setShowShadow(
        ref.current.scrollLeft <
          ref.current.scrollWidth - ref.current.clientWidth,
      )
    }
  }

  const debouncedHandleScroll = useDebouncedCallback(handleScroll, 50, {
    maxWait: 250,
  })

  const current = ref.current

  useEffect(() => {
    if (current) {
      current.addEventListener('scroll', debouncedHandleScroll)
    }

    return () => {
      if (current) {
        current.removeEventListener('scroll', debouncedHandleScroll)
      }
    }
  }, [debouncedHandleScroll, current])

  return showShadow
}

export { useShowScrollShadow }
